import { map } from "lodash";
import React from "react";
import SkeletonListItem from "../../../../../../components/SkeletonListItem";

import { formatDate, parseTimestamp } from "../../../../../../utils/dateFns";

import { formatMonetary } from "../../../../../../utils/formats";

import {
  Column,
  ColumnContentWrapper,
  FlexWrapper,
  Header,
  HeaderRow,
  Row,
  Table,
  TBody,
  THead,
} from "./styles";

const ListTituloGrupoTable = (props) => {
  const { isLoading } = props;

  const HeaderColumn = (headerProps) => {
    const { children, width } = headerProps;

    return (
      <Header width={width} clickable={false}>
        <FlexWrapper justify="space-between">{children}</FlexWrapper>
      </Header>
    );
  };

  const renderHeader = () => {
    return (
      <THead>
        <HeaderRow>
          <HeaderColumn id="codigoEmpresaOrigem">Empresa</HeaderColumn>
          <HeaderColumn id="NULL">Nota Fiscal</HeaderColumn>
          <HeaderColumn id="especieNotaFiscal">Espécie</HeaderColumn>
          <HeaderColumn id="dataEmissao">Emissão NF</HeaderColumn>
          <HeaderColumn id="dataVencimento">Vencimento</HeaderColumn>
          <HeaderColumn id="valorTitulo">Valor título</HeaderColumn>
          <HeaderColumn id="valorPago">Valor pago</HeaderColumn>
          <HeaderColumn id="diasEmAtraso">Dias em atraso</HeaderColumn>
        </HeaderRow>
      </THead>
    );
  };

  const renderBody = () => {
    const { logs } = props;

    return (
      <TBody>
        {map(logs, (it) => {
          const parsedDateEmissao = parseTimestamp(it.dataEmissao);
          const parsedDateVencimento = parseTimestamp(it.dataVencimento);
          return (
            <Row key={it.id}>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.codigoEmpresaOrigem}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">-</FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.especieNotaFiscal ? it.especieNotaFiscal : "-"}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {formatDate(parsedDateEmissao)}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {formatDate(parsedDateVencimento)}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {formatMonetary(it.valorTitulo)}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {formatMonetary(it.valorPago)}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
              <Column>
                <ColumnContentWrapper>
                  <FlexWrapper justify="flex-start">
                    {it.diasEmAtraso}
                  </FlexWrapper>
                </ColumnContentWrapper>
              </Column>
            </Row>
          );
        })}
      </TBody>
    );
  };

  return (
    <>
      {isLoading ? (
        <SkeletonListItem />
      ) : (
        <Table>
          {renderHeader()}
          {renderBody()}
        </Table>
      )}
    </>
  );
};

export default ListTituloGrupoTable;
